import React, { forwardRef } from 'react';

import { t } from '@/utils/helper/intl';

import CloseIcon from './icon/close';

export interface UploadUploadingProps {
  percent: number | string;
  slotNode?: (percent: number | string, onCancel?: () => void) => React.ReactNode;
  onCancel?: () => void;
}

const ProgressBar: React.FC<{ percent: number | string }> = React.memo(({ percent }) => (
  <div className="w-[400px] relative h-[4px] flex items-center rounded-[2px] bg-common-modal-upload-popover-progress-track-color overflow-hidden">
    <div
      className="progress bg-common-modal-upload-popover-progress-color absolute left-0 h-[4px] rounded-[2px] transition-all"
      style={{ width: `${percent}%` }}
    />
  </div>
));

const Uploading = forwardRef<HTMLDivElement, UploadUploadingProps>((props, ref) => {
  const { percent, onCancel, slotNode } = props;

  return (
    <div ref={ref} className={`wrapper-upload-step w-full h-full`}>
      {slotNode ? (
        slotNode(percent, onCancel)
      ) : (
        <div className="w-full h-full flex flex-col items-center justify-center">
          <div className="pb-[8px]">
            <ProgressBar percent={percent} />
          </div>
          <div className="pb-[18px] flex items-center gap-[8px]">
            <span className="text-[14px] font-[500] leading-[20px] font-sans">
              {t('merror.language.uploading')}...
            </span>
            <span className="text-[14px] font-[600] leading-[16px] tracking-[0.5px] font-number">
              {percent}%
            </span>
          </div>

          <div
            className="cursor-pointer"
            onClick={(e) => {
              e && e.stopPropagation();
              onCancel && onCancel();
            }}
          >
            <CloseIcon />
          </div>
        </div>
      )}
    </div>
  );
});
export default Uploading;
